import fetch from 'isomorphic-fetch'
import {getStore} from '../common/store'
import queryString from 'query-string'
import ReactGA from 'react-ga'
import {GoogleConversionPixel, FacebookTrackingPixel} from '../views/conversion'

const frequencyMapping = (textValue) => {
  switch (textValue) {
    case 'monthly':
      return 2
    case 'one-time':
      return 1
  }
}

const validateParams = (params) => {
  if (!params.amount || !params.amount.amount || !params.amount.frequency) {
    throw new Error('Invalid amount. Must have amount and frequency')
  }
  if (!params.token && !params.cardId && params.customerId) {
    throw new Error(
      'Must specify card token or an existing cardId and customerId'
    )
  }
  if (!params.userToken && !params.email) {
    throw new Error('Must specify a JWT token (userToken) or an email')
  }
}

export const fetchCards = async (token) => {
  let url =
    getStore().getState().config.serviceUrl + '/api/v1/payments/stripe/cards'
  url += '?charityId=' + getStore().getState().config.charityId
  url += '&userToken=' + token

  const response = await fetch(url, {method: 'POST'})
  const responseBody = await response.text()
  return JSON.parse(responseBody).cards
}

export const executePayment = async (params, recaptchaToken) => {
  // console.info('Will execute a donation with the following parameters:', params)
  validateParams(params)

  let url = `${
    getStore().getState().config.serviceUrl
  }/api/v1/payments/stripe?charityId=${
    getStore().getState().config.charityId
  }&recaptchaToken=${recaptchaToken}`

  let segments = []
  let body = {}
  if (params.token) {
    url += '&token=' + params.token
  }
  if (params.cardId) {
    body.cardId = params.cardId
  }
  if (params.customerId) {
    body.inputCustomerId = params.customerId
  }
  if (params.firstName) {
    body.firstName = params.firstName
  }
  if (params.lastName) {
    body.lastName = params.lastName
  }
  if (params.phoneNumber) {
    body.phoneNumber = params.phoneNumber
  }
  if (params.donorList) {
    body.saveToList = params.donorList
  }
  if (params.source) {
    body.utmSource = params.source
  }
  if (params.medium) {
    body.utmMedium = params.medium
  }
  if (params.mot) {
    body.motivationCode = params.mot
  }
  // NOTE: some charities wanted to start using qrcodes before this feature rolled
  // out, the only way to track we had was using motivation code, that's why
  // we also use mot==="QRCode" here
  if ((params.QRCode && Boolean(params.QRCode)) || params.mot === 'QRCode') {
    segments.push('QRCode Donors')
  }
  if (params.campaign) {
    body.campaign = params.campaign !== 'default' ? params.campaign : 'Default'
  }

  body.amount = (params.amount.amount * 100).toFixed(0)
  body.frequency = frequencyMapping(params.amount.frequency)
  body.saveInfo = params.saveInfo
  if (params.userToken) {
    body.userToken = params.userToken
  } else {
    body.guestEmail = params.email
  }
  if (params.projectId) {
    body.projectId = params.projectId
  }
  if (params.feesAssumed != null) {
    body.feesAssumed = params.feesAssumed
  }
  if (params.extraMetadata) {
    body.extraMetadata = params.extraMetadata
  }
  if (segments.length) {
    body.segments = segments.join(';')
  }

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'content-type': 'application/json',
    },
  })
  const responseBody = await response.text()
  let success = responseBody === 'succeeded'
  const trackingId = getStore().getState().config.trackingId
  if (
    success &&
    getStore().getState().config.stringValues.bfTracking &&
    trackingId
  ) {
    ReactGA.initialize(trackingId)
    if (window) {
      const parsed = queryString.parse(window.location.search)
      if (parsed.google) {
        GoogleConversionPixel.loadPixel(params.amount.amount)
      }

      FacebookTrackingPixel.loadPixel('Purchase', params.amount.amount)
      FacebookTrackingPixel.loadPixel(
        'CompleteRegistration',
        params.amount.amount
      )
    }
  }

  return success
}
